import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useSmartAccountContext } from "./context/SmartAccountContext/SmartAccountContext";
import { useGlobalContext } from "./context/GlobalContext/GlobalContext";
import Loader from "./layouts/Loader";
import Layout from "./layouts/Layout";
import Home from "./pages/Home";
import StatusScreen from "./pages/StatusScreen";
import UserWallet from "./pages/UserWallet";
import { useWeb3AuthContext } from "./context/SocialLoginContext/SocialLoginContext";

// import Widget from "./pages/Widget";

const App: React.FC = () => {
  const { loading } = useSmartAccountContext();
  const { loading:web3authLoading } = useWeb3AuthContext()
  const { appLoading } = useGlobalContext(); // TODO: Remove 2 loading states and use only one from GlobalContext

  if (loading || appLoading || web3authLoading) return <Loader />;

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/wallet" element={<UserWallet />} />
          <Route path="/success" element={<StatusScreen status={true} />} />
          <Route path="/failed" element={<StatusScreen status={false} />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
